import React, { useCallback, useMemo, useState } from 'react';
import useWhitelabelFeatures from 'hooks/whitelabel/useWhitelabelFeatures';
import RedeemPointsConfirmationModal from './RedeemPointsConfirmationModal';
import useRedeemConfirmation from './hooks/useRedeemConfirmation';
import { RedeemContext } from './RedeemHandlerContext';
import useRedeemModalToggle from './hooks/useRedeemModalToggle';

/**
 * @description Redeem handler
 */
const RedeemHandler = () => {
  const { OPT_CONTACT_METHOD_AT_REDEEM_POINTS: optContactMethod } = useWhitelabelFeatures();
  const [selectedMethod, setSelectedMethod] = useState(
    optContactMethod === 'both' ? 'email' : optContactMethod,
  );
  const redeemModalToggle = useRedeemModalToggle();

  const {
    isCreating,
    isConfirming,
    timerActive,
    codeSent,
    error,
    reset,
    createNITCode,
    confirmNITCode,
  } = useRedeemConfirmation({
    onSuccessConfirmation: () => {
      redeemModalToggle();
    },
  });

  const handleReset = useCallback(() => {
    reset();
    setSelectedMethod(optContactMethod === 'both' ? 'email' : optContactMethod);
  }, [optContactMethod, reset]);

  const contextValue = useMemo(
    () => ({
      isCreating,
      isConfirming,
      timerActive,
      codeSent,
      optContactMethod,
      selectedMethod,
      error,
      onClose: () => redeemModalToggle(),
      onSendCode: () => createNITCode(selectedMethod),
      onConfirm: (code) => confirmNITCode(code),
      onSelectMethod: setSelectedMethod,
      onReset: handleReset,
    }),
    [
      optContactMethod,
      confirmNITCode,
      isCreating,
      isConfirming,
      timerActive,
      codeSent,
      error,
      selectedMethod,
      redeemModalToggle,
      createNITCode,
      handleReset,
    ],
  );

  return (
    <RedeemContext.Provider value={contextValue}>
      <RedeemPointsConfirmationModal />
    </RedeemContext.Provider>
  );
};

RedeemHandler.propTypes = {};

export default RedeemHandler;
